import { render, staticRenderFns } from "./InfinityUpgradesTab.vue?vue&type=template&id=01171e7f&scoped=true&"
import script from "./InfinityUpgradesTab.vue?vue&type=script&lang=js&"
export * from "./InfinityUpgradesTab.vue?vue&type=script&lang=js&"
import style0 from "./InfinityUpgradesTab.vue?vue&type=style&index=0&id=01171e7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01171e7f",
  null
  
)

export default component.exports